import React from "react";
import { ConfirmationDialog } from "@SeemplicityDev/shared";
import "./StaticErrorFallback.scss";

// TODO: ConfirmationDialog's button prop type is not exported from
// @SeemplicityDev/shared; this mirrors the runtime shape passed by callers.
// buttonStyle mirrors TextButtonProps["buttonStyle"] (ButtonStyle | "" | false).
interface StaticErrorFallbackButton {
  label: string;
  onClick: () => void;
  buttonStyle?:
    | "default"
    | "danger"
    | "secondary"
    | "textLink"
    | "invert"
    | "ai"
    | "ai-outline"
    | "ai-inverted"
    | "warning"
    | "menu"
    | "primary"
    | ""
    | false;
  "data-testid"?: string;
}

interface StaticErrorFallbackProps {
  error: { message: string };
  buttons?: StaticErrorFallbackButton[];
}

const StaticErrorFallback: React.FC<StaticErrorFallbackProps> = ({
  error,
  buttons = [],
}) => {
  const dialogProps = {
    type: "error" as const,
    message: error.message,
    buttons,
    showCloseIcon: false,
  };

  return (
    <div className={"static-fallback-container"} data-testid={"error-fallback"}>
      <ConfirmationDialog {...dialogProps} />
    </div>
  );
};

export default StaticErrorFallback;
